'use client'; // must run on the browser

import type { HistoricalForecasts } from 'models';

import { ForecastWorkerClient } from './historicalForecastWorkerClient';

// Reuse a single long-lived worker client across calls instead of constructing
// (and terminating) a Worker on every call. The forecast-history poll runs on a
// repeating setInterval on every live Event/BinaryMarket, so new-per-call would
// spin up and tear down a Web Worker on every tick — leaking workers and their
// pending closures whenever a call hangs/errors or the component unmounts
// mid-flight. The client lazily (re-)creates its underlying Worker on first use
// and after a faulted worker, so a stale singleton can't wedge later calls. The
// caller (utils/charting.ts `asyncMapForecastsHistory`) still falls back to the
// main thread if `call()` rejects, so a dead worker degrades rather than breaks.
let sharedClient: ForecastWorkerClient | null = null;

const getSharedClient = (): ForecastWorkerClient => {
    if (sharedClient === null) {
        sharedClient = new ForecastWorkerClient();
    }
    return sharedClient;
};

export async function runExtrapolateHistoricalForecast(
    forecastHistory: HistoricalForecasts[],
): Promise<HistoricalForecasts[]> {
    const response = await getSharedClient().call({
        action: 'computeForecasts',
        payload: { forecastHistory },
    });

    if (response.error) throw new Error(response.error);

    return response.result;
}
